import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { DynamicValue } from '@/types'
import axios from 'axios'

// Used when the API has no value for a key, so the app works before anything is set up.
const fallbacks = {
  your_vehicle: 'dit køretøj',
  vehicle_view_title: 'Dit køretøj',
  manual_vehicle_view_title: 'Dit køretøj',
  vehicle: 'bil',
  brand: 'mærke',
  model: 'model',
  engine: 'motor',
  brands: 'mærker',
  models: 'modeller',
  engines: 'motorer',
  carPlateLabel: 'reg.nr. eller VIN',
  manualVehicleLabel: 'Vælg mærke, model og motor',
  registrationYearLabel: 'Hvornår er bilen fra?',
  mileageLabel: 'Hvor langt har dit køretøj kørt?',
  vehicle_icon: 'mdi-car-outline' // type "icon"
}

export type DynamicTextKey = keyof typeof fallbacks

export const useDynamicTextStore = defineStore('dynamicText', () => {
  const values = ref<Record<string, string>>({})

  async function getValues() {
    try {
      // The API finds the dealer from the URL and returns its values, falling back to the defaults
      const { data } = await axios.get<DynamicValue[]>('app/dynamic-values')

      values.value = Object.fromEntries(data.map(x => [x.key, x.value]))
    } catch (error) {
      // Not fatal, the fallback texts are used instead
      console.error(error)
    }
  }

  function t(key: DynamicTextKey): string {
    return values.value[key] || fallbacks[key]
  }

  return { values, getValues, t }
})
